export const resizeImage = (
  screenShot: string | File | Blob,
  max_size: number = 1920,
): Promise<string> => {
  return new Promise((resolve) => {
    let imgSource = "";
    if (screenShot instanceof Blob) {
      imgSource = URL.createObjectURL(screenShot);
    } else {
      imgSource = screenShot;
    }

    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement("canvas");

      let { width } = img;
      let { height } = img;
      if (width > height && width > max_size) {
        height *= max_size / width;
        width = max_size;
      } else if (height > max_size) {
        width *= max_size / height;
        height = max_size;
      }

      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d")?.drawImage(img, 0, 0, width, height);
      const resizeImage = canvas.toDataURL("image/jpeg");
      resolve(resizeImage);
    };
    img.src = imgSource;
  });
};
